import { cn } from "@/lib/utils";
import { DatasetFilter } from "@/types/dataset";

import SavedFilterCard from "./SavedFilterCard";

type SavedAdmAreaProps = {
  filter?: DatasetFilter;
  disabled?: boolean;
  onEdit?: (filter: DatasetFilter) => void;
  onDelete?: (filter: DatasetFilter) => void;
};

const SavedAdmArea = ({
  filter,
  disabled,
  onEdit,
  onDelete
}: SavedAdmAreaProps) => {
  if (!filter) return null;
  return (
    <div className="space-y-3 font-sans" data-testid="saved-adm-area">
      <SavedFilterCard
        filter={filter}
        title="Adm. Area"
        content={
          <div
            className={cn(
              "text-xs text-txtPlaceholder",
              disabled && "text-light-gray"
            )}
          >
            Total adm area selected{" "}
            <span
              className={cn(
                "text-txtHeading font-semibold",
                disabled && "text-light-gray"
              )}
            >
              (
              {filter.is_multiple_adm_area
                ? (filter.selectedOptions?.length ?? 0)
                : 1}
              )
            </span>
          </div>
        }
        onEdit={onEdit}
        onDelete={onDelete}
        disabled={disabled}
      />
    </div>
  );
};

export default SavedAdmArea;
